import { render } from "./DeletedContent.vue?vue&type=template&id=d5aedf58&scoped=true"
import script from "./DeletedContent.vue?vue&type=script&lang=js"
export * from "./DeletedContent.vue?vue&type=script&lang=js"

import "./DeletedContent.vue?vue&type=style&index=0&id=d5aedf58&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5aedf58"]])

export default __exports__